var mySpinner;
(function (mySpinner) {
    var theSpinner = new Spinner({
        lines: 13,
        length: 20,
        width: 10,
        radius: 30,
        corners: 1,
        rotate: 0,
        direction: 1,
        color: '#000',
        speed: 2,
        trail: 60,
        shadow: true,
        hwaccel: false,
        className: 'spinner',
        zIndex: 2e9,
        top: '200px',
        left: '50%' // Left position relative to parent
    });
    var depth = 0;
    var timerWaitingToShow;
    var elementId;
    var defaultElementId = 'rootDiv';
    var minimumMsToShow = 250;
    var delayMsBeforeShow = 250;

    mySpinner.setDefaultElement = setDefaultElement;
    mySpinner.setElement = setElement;
    mySpinner.show = show;
    mySpinner.hide = hide;

    function setDefaultElement(newId) {
        this.defaultElementId = newId;
    }

    function setElement(newId) {
        this.elementId = newId;
    }

    function show() {
        var self = this;
        depth++;
        if (depth === 1) {
            timerWaitingToShow = setTimeout(function () {
                timerWaitingToShow = null;
                theSpinner.spin(document.getElementById(self.elementId || defaultElementId));
            }, delayMsBeforeShow);
        }
    }

    function hide() {
        if (timerWaitingToShow) {
            depth--;
            if (depth <= 0) {
                clearTimeout(timerWaitingToShow);
                depth = 0;
            }
        } else {
            setTimeout(function () {
                depth--;
                if (depth <= 0) {
                    theSpinner.stop();
                    depth = 0;
                }
            }, minimumMsToShow);
        }
    }
})(mySpinner || (mySpinner = {}));
